import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { useAppContext } from "@/src/config/AppProvider";
import { useHomePageContext } from "@/src/features/home/HomePageContext";

const TeamSection = () => {
  const { t } = useTranslation();
  const { getLocalization } = useAppContext();

  return (
    <div className="rbt-team-area bg-color-white rbt-section-gap">
      <div className="container">
        <div className="row mb--60">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <span className="subtitle bg-primary-opacity">{t("ourTeam")}</span>
              <h2 className="title">{getLocalization("ourTeamSlogan")}</h2>
            </div>
          </div>
        </div>
        <Team />
      </div>
    </div>
  );
};

const Team = (): ReactNode => {
  const { licenceSettings } = useAppContext();
  const { employees } = useHomePageContext();

  const isActive = (idGuid: string): boolean => employees?.[0]?.IdGuid === idGuid;

  return (
    <div className="row g-5">
      <div className="col-lg-7">
        <div className="rbt-team-tab-content tab-content" id="teamTabContent">
          {employees.map(item => {
            return (
              <div
                className={`tab-pane fade ${isActive(item.IdGuid) ? "active" : ""} show`}
                id={`team-tab${item.IdGuid}`}
                role="tabpanel"
                aria-labelledby={`team-tab${item.IdGuid}-tab`}
                key={item.IdGuid}
              >
                <div className="inner">
                  <div className="rbt-team-thumbnail">
                    <div className="thumb">
                      <Image src={item.ProfileImage} width={415} height={555} priority alt={item.FirstName + " " + item.LastName} />
                    </div>
                  </div>
                  <div className="rbt-team-details">
                    <div className="author-info">
                      <h4 className="title">
                        {item.FirstName} {item.LastName}
                      </h4>
                      <span className="designation theme-gradient">{item.JobTitle}</span>
                      <span className="team-form">
                        <i className="feather-map-pin mr--5"></i>
                        <span>{licenceSettings.SiteTitle}</span>
                      </span>
                    </div>
                    <p className="text-multiline-ellipsis-6">{item.Bio}</p>
                    {item.SocialMediaLinks.map(social => (
                      <div className="read-more-btn" key={social.IdGuid}>
                        <a className="rbt-moderbt-btn" href={social.PlatformUrl} target="_blank">
                          <span className="moderbt-btn-text">{social.PlatformName}</span>
                          <i className="feather-arrow-right"></i>
                        </a>
                      </div>
                    ))}

                    <ul className="rbt-information-list mt--10">
                      <li>
                        <Link href={`mailto:${item.Email}`}>
                          <i className="feather-mail"></i>
                          {item.Email}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="top-circle-shape"></div>
        </div>
      </div>

      <div className="col-lg-5">
        <ul className="rbt-team-tab-thumb nav nav-tabs" id="team" role="tablist">
          {employees.map(item => (
            <li key={item.IdGuid}>
              <Link
                className={`${isActive(item.IdGuid) ? "active" : ""}`}
                id={`team-tab${item.IdGuid}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#team-tab${item.IdGuid}`}
                role="tab"
                aria-controls={`team-tab${item.IdGuid}`}
                aria-selected={isActive(item.IdGuid)}
                href="#"
              >
                <div className="rbt-team-thumbnail">
                  <div className="thumb">
                    <Image src={item.ProfileImage} width={415} height={555} priority alt={item.FirstName + " " + item.LastName} />
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TeamSection;
